// components/Navbar.jsx
import React from "react";
import { useScene } from "./scene/SceneContext";

export default function NavBar({
  className = "",
  brandSubtitle,
  brandSubtitleClassName = "",
  settingsBtnIconClassName = "",
  shareBtnIconClassName = "",
  showActionBtn = false,
  handleSettingsBtnOnClick,
  handleShareBtnOnClick,
  // Landing page uses the older "single action" API (info button).
  actionBtnIconClassName = "",
  handleActionBtnOnClick,
  actionButtonClassName = "btn btn-sm as-btn-soft",
  rightSlot,
}) {
  const { variant } = useScene();

  const normalizeIconClassName = (iconClassName) => {
    if (!iconClassName) return "";
    // Bootstrap Icons require the base `bi` class, but callers often pass only `bi-xxx`.
    if (iconClassName.startsWith("bi-") && !iconClassName.includes("bi ")) {
      return `bi ${iconClassName}`;
    }
    return iconClassName;
  };

  const logoSrc = `${process.env.PUBLIC_URL || ""}/images/logo/logo.png`;
  const brandHref = `${process.env.PUBLIC_URL || ""}/`;

  const hasSingleAction =
    showActionBtn && actionBtnIconClassName && typeof handleActionBtnOnClick === "function";

  const hasShare = showActionBtn && typeof handleShareBtnOnClick === "function";
  const hasSettings = showActionBtn && typeof handleSettingsBtnOnClick === "function";

  return (
    <nav
      className={`navbar as-navbar as-navbar--${variant} ${className}`.trim()}
      data-scene-variant={variant}
    >
      <div className="container-fluid d-flex align-items-center justify-content-between">
        <a className="navbar-brand align-text-bottom" href={brandHref}>
          <img
            src={logoSrc}
            alt="AnimalSplit logo"
            width="30"
            height="30"
            className="d-inline-block align-top"
          />{" "}
          <span>AnimalSplit</span>
          {brandSubtitle ? (
            <span className={`ms-2 as-navbar-subtitle ${brandSubtitleClassName}`.trim()}>
              {brandSubtitle}
            </span>
          ) : null}
        </a>

        <div className="d-flex align-items-center gap-2">
          {hasSingleAction ? (
            <button
              type="button"
              className={actionButtonClassName}
              onClick={handleActionBtnOnClick}
            >
              <i className={normalizeIconClassName(actionBtnIconClassName)} />
            </button>
          ) : (
            <>
              {hasShare ? (
                <button
                  type="button"
                  className={actionButtonClassName}
                  onClick={handleShareBtnOnClick}
                >
                  <i className={normalizeIconClassName(shareBtnIconClassName)} />
                </button>
              ) : null}
              {hasSettings ? (
                <button
                  type="button"
                  className={actionButtonClassName}
                  onClick={handleSettingsBtnOnClick}
                >
                  <i className={normalizeIconClassName(settingsBtnIconClassName)} />
                </button>
              ) : null}
            </>
          )}

          {rightSlot ? rightSlot : null}
        </div>
      </div>
    </nav>
  );
}
